import styled from 'styled-components'
import { Card, Text, Flex } from 'pcln-design-system'

export const Wrapper = styled(Card)`
  cursor: pointer;
`

export const SavingsPercentText = styled(Text)`
  white-space: nowrap;
`

export const IconContainer = styled(Flex)`
  cursor: pointer;
`
